import { cn } from "../../utils";
import { Icon } from "../../icons";

/**
 * The live to-do / plan checklist (P4.1 / D3) — the latest TodoWrite snapshot.
 * Completed items get a check + strike, the in-progress one a pulsing dot, the
 * rest a hollow dot. Compact enough for the 288px rail.
 */
export function TodoList({
  items,
}: {
  items: Array<{ content: string; status: string }>;
}) {
  if (!items.length) return null;
  const done = items.filter((i) => i.status === "completed").length;
  return (
    <div className="rounded-md border border-border/40 bg-secondary/20 p-2">
      <p className="mb-1 type-subtext text-muted-foreground">
        Plan · {done}/{items.length}
      </p>
      <ul className="space-y-0.5">
        {items.map((item, i) => {
          const isDone = item.status === "completed";
          const isActive = item.status === "in_progress";
          return (
            <li key={i} className="flex items-start gap-1.5 type-subtext">
              {isDone ? (
                <Icon
                  name="check"
                  size="xs"
                  className="mt-0.5 shrink-0 text-emerald-500"
                />
              ) : (
                <span
                  className={cn(
                    "mt-1 size-1.5 shrink-0 rounded-full",
                    isActive ? "animate-pulse bg-chart-1" : "bg-muted-foreground/40",
                  )}
                  aria-hidden
                />
              )}
              <span
                className={cn(
                  "min-w-0",
                  isDone
                    ? "text-muted-foreground line-through"
                    : isActive
                      ? "text-foreground"
                      : "text-muted-foreground",
                )}
              >
                {item.content}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
